import Header from './components/Header';
import Hero from './components/Hero';
import Topics from './components/Topics';
import AppEntry from './components/AppEntry';
import IndexSection from './components/IndexSection';
import Contact from './components/Contact';
import About from './components/About';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import Carousel from './components/Carousel';
import Features from './components/Features';
import Ranking from './components/Ranking';
import Updates from './components/Updates';
import Comments from './components/Comments';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Topics />
        <AppEntry />
        <IndexSection />
        <Contact />
        <About />
        <MediaSection />
        <CardsSection />
        <Carousel />
        <Features />
        <Ranking />
        <Updates />
        <Comments />
        <FAQ />
      </main>
      <Footer />
    </>
  );
}